<template>
    <div
        class="relative"
        @mouseenter="openDropdown"
        @mouseleave="closeDropdownWithDelay"
    >
        <div class="flex items-center gap-1">
            <Link v-if="item.route_name"
                  :href="route(item.route_name, item.route_params || {})"
                  class="text-[15px] text-white/90 transition hover:text-baseColor">
                {{ item.label }}
            </Link>
            <div v-else class="text-[15px] text-white/90 transition hover:text-baseColor cursor-default">
                {{ item.label }}
            </div>

            <button
                type="button"
                class="group flex h-6 w-6 items-center justify-center text-white/90 transition hover:text-baseColor"
                @click.stop="toggleDropdown"
                aria-label="Открыть подменю"
            >
                <IconChevronDown
                    class="mt-px h-3 w-3 transition duration-300"
                    :class="isOpen ? 'rotate-180 text-baseColor' : ''"
                />
            </button>
        </div>

        <transition name="dropdown">
            <div
                v-if="isOpen"
                class="absolute left-0 top-full z-50 pt-4"
                @mouseenter="clearCloseTimer"
                @mouseleave="closeDropdownWithDelay"
            >
                <div
                    class="relative min-w-[300px] overflow-hidden rounded-[22px] border border-white/10 bg-[#0b0b0b]/95 p-2 shadow-[0_20px_60px_rgba(0,0,0,0.45)] backdrop-blur-xl"
                >
                    <div
                        class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,196,0,0.12),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.04),transparent_24%)]"
                    ></div>

                    <div class="relative flex flex-col gap-1">
                        <Link
                            v-for="child in item.children"
                            :key="child.label"
                            :href="route(child.route_name, child.route_params || {})"
                            class="group rounded-[16px] px-4 py-3 transition hover:bg-white/[0.04]"
                            @click="handleItemClick"
                        >
                            <div
                                class="flex items-center justify-between gap-3 text-[14px] font-medium text-white transition group-hover:text-baseColor"
                            >
                                <span>{{ child.label }}</span>
                                <span
                                    class="h-1 w-1 shrink-0 rounded-full bg-baseColor/70 opacity-0 transition group-hover:opacity-100"
                                ></span>
                            </div>

                            <p
                                v-if="child.description"
                                class="mt-1 text-xs leading-5 text-white/50"
                            >
                                {{ child.description }}
                            </p>
                        </Link>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {Link} from '@inertiajs/vue3'
import IconChevronDown from '@js/components/Icons/IconChevronDown.vue'

export default {
    name: 'TopBarDropdown',
    components: {
        Link,
        IconChevronDown,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    emits: ['item-click'],
    data() {
        return {
            isOpen: false,
            closeTimer: null,
        }
    },
    methods: {
        toggleDropdown() {
            this.clearCloseTimer()
            this.isOpen = !this.isOpen
        },
        openDropdown() {
            this.clearCloseTimer()
            this.isOpen = true
        },
        closeDropdown() {
            this.clearCloseTimer()
            this.isOpen = false
        },
        closeDropdownWithDelay() {
            this.clearCloseTimer()

            this.closeTimer = setTimeout(() => {
                this.isOpen = false
            }, 120)
        },
        clearCloseTimer() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer)
                this.closeTimer = null
            }
        },
        handleItemClick() {
            this.isOpen = false
            this.$emit('item-click')
        },
    },
    beforeUnmount() {
        this.clearCloseTimer()
    },
}
</script>

<style scoped lang="scss">
.dropdown-enter-active,
.dropdown-leave-active {
    transition: all 0.22s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
}

.dropdown-enter-to,
.dropdown-leave-from {
    opacity: 1;
    transform: translateY(0) scale(1);
}
</style>
